import { Trash } from "@phosphor-icons/react";

const STATUS_STYLES = {
  published: "bg-emerald-50 text-emerald-700 border-emerald-200",
  archived: "bg-zinc-100 text-zinc-600 border-zinc-200",
  draft: "bg-amber-50 text-amber-700 border-amber-200",
};

export const statusBadge = (s) =>
  `text-xs px-2 py-0.5 border font-mono uppercase tracking-wider ${STATUS_STYLES[s] || STATUS_STYLES.draft}`;

export default function TemplatesTable({ items, onToggleStatus, onDelete }) {
  return (
    <div className="mt-6 border border-zinc-200 bg-white" data-testid="admin-templates-table">
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr className="border-b border-zinc-200 text-left gf-overline">
            <th className="px-6 py-3">Title</th>
            <th className="px-6 py-3">Category</th>
            <th className="px-6 py-3">Price</th>
            <th className="px-6 py-3">Status</th>
            <th className="px-6 py-3 text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.map((t) => (
            <tr key={t.id} className="border-b border-zinc-100 hover:bg-zinc-50">
              <td className="px-6 py-4 font-semibold max-w-md truncate">{t.title}</td>
              <td className="px-6 py-4 text-zinc-600 font-mono text-xs">{t.category}</td>
              <td className="px-6 py-4 font-mono">${Number(t.price_usd).toFixed(2)}</td>
              <td className="px-6 py-4">
                <button onClick={() => onToggleStatus(t)} data-testid={`tpl-status-${t.id}`} className="hover:opacity-80">
                  <span className={statusBadge(t.status)}>{t.status}</span>
                </button>
              </td>
              <td className="px-6 py-4 text-right">
                <button
                  onClick={() => onDelete(t)}
                  data-testid={`tpl-delete-${t.id}`}
                  className="inline-flex items-center gap-1 text-red-700 hover:underline text-xs uppercase tracking-wide font-bold"
                >
                  <Trash size={14} /> Delete
                </button>
              </td>
            </tr>
          ))}
          {items.length === 0 && (
            <tr><td colSpan={5} className="px-6 py-12 text-center text-zinc-500 text-sm">No templates yet.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
